define(function(require) {
    const BaseView = require('app/Base.view');

    // Orthogonal data constants: https://datatables.net/manual/data/orthogonal-data
    // Uncomment when use cases are discovered
    const DISPLAY_KEY = 'display';
    //const SORT_KEY = 'sort';
    const EXPORT_KEY = 'export';
    //const FILTER_KEY = 'filter';
    //const DATA_TYPE_KEY = 'type';

    const Cell = BaseView.extend({
        defaults: function() {
            return {
                ExportOnlyCell: false,
                className: 'all',
                wrapHeader: false
            };
        },

        initialize: function(options, dataGrid) {
            BaseView.prototype.initialize.apply(this, arguments);

            const dataName = this.data || this.title || this.prefix;
            if (!dataName) {
                throw new Error('DataGrid: Cell must have a dataName or title or prefix');
            }
            if (typeof dataName !== 'string') {
                throw new Error(`DataGrid: dataName must be a string, got ${typeof dataName}`);
            }
            const name = dataName.replace(/\./g, '-').toLowerCase();
            this.className = `data-grid-col__${name}${this.className ? ` ${this.className}` : ''}`;
            if (this.data !== null) {
                this.name = name;
            }
            this.parent = dataGrid;
            this.collection = dataGrid.collection;

            if (options.idAttribute) {
                this.idAttribute = options.idAttribute;
            } else {
                this.idAttribute = this.collection.model.prototype.idAttribute || 'id';
            }
        },

        /**
         * Custom translation of the data value - No templates of html here
         *
         * @param {Any} data The data for the cell
         * @param {Any} row THe full data source for the row
         * @param {Backbone.Model} the model for the row
         * @returns the translated data
         */
        onGetData: function(data, row, model) {
            return data;
        },

        /**
         * Rendering the display version of this cell
         * @param {Any} data The data for the cell
         * @param {String} type The type of cell data
         * @param {Any} row THe full data source for the row
         * @param {Object} meta Additional info about the cell
         * @param {Any} translatedValue Data transformed through onGetData
         * @param {Backbone.Model} model The model associated with this row
         */
        onDisplay: function(data, type, row, meta, translatedValue, model) {
            return data;
        },

        /**
         * Rendering the export version of this cell
         * @param {Any} data The data for the cell
         * @param {String} type The type of cell data
         * @param {Any} row THe full data source for the row
         * @param {Object} meta Additional info about the cell
         * @param {Any} translatedValue Data transformed through onGetData
         * @param {Backbone.Model} model The model associated with this row
         */
        onExport: function(data, type, row, meta, translatedValue, model) {
            return data;
        },

        /**
         * Data Tables Render Method
         * @private Use onDisplay etc to change functionality
         *
         * @link https://datatables.net/reference/option/columns.render
         * @param {Any} data The data for the cell
         * @param {String} type The type of cell data
         * @param {Any} row THe full data source for the row
         * @param {Object} meta Additional info about the cell
         * @param {Object} model Only available in Lotame contexts
         * @returns what will be used for the cell
         */
        render: function(data, type, row, meta, model) {
            const translatedValue = this.onGetData(data, row, this.findModel(model, row));
            switch (type) {
                case DISPLAY_KEY:
                    return this.onDisplay(data, type, row, meta, translatedValue, model);
                case EXPORT_KEY:
                    return this.onExport(data, type, row, meta, translatedValue, model);
            }
            return translatedValue;
        },

        findModel: function(model, row) {
            if (model) {
                return model;
            }

            const rowId = row[this.idAttribute];
            const foundModel = this.collection.get(rowId);
            if (foundModel) {
                return foundModel;
            }

            // Fall back in cases where id attribute must not be set up correctly
            const filter = {};
            filter[this.idAttribute] = rowId;
            const foundByFilter = this.collection.findWhere(filter);
            if (foundByFilter) {
                return foundByFilter;
            }

            // Maybe we need to use the full collection?
            if (this.collection.fullCollection) {
                const foundByFullCollection = this.collection.fullCollection.get(rowId);
                if (foundByFullCollection) {
                    return foundByFullCollection;
                }
            }
        },

        /**
         *
         * @returns This cell as a column definition needed by DataTables
         */
        toColumn: function() {
            return {
                /**
                 * DataTables column fields
                 * @link https://datatables.net/reference/option/columns
                 */
                cellType: this.cellType,
                className: this.className,
                contentPadding: this.contentPadding,
                createdCell: this.createdCell,
                data: this.data,
                defaultContent: this.defaultContent,
                name: this.name,
                orderable: this.orderable,
                orderData: this.orderData,
                orderDataType: this.orderDataType,
                orderSequence: this.orderSequence,
                render: this.render.bind(this),
                searchable: this.searchable,
                sortable: this.sortable,
                title: this.title,
                type: this.type,
                visible: this.visible,
                width: this.width,

                /**
                 * Custom fields added by us
                 */

                // keeps the column from showing up in the manager
                ExportOnlyCell: this.ExportOnlyCell,

                prefix: this.prefix,
                optional: this.optional,
                tooltip: this.tooltip
            };
        }
    });

    return Cell;
});
